module.exports = __webpack_public_path__ + "static/media/userBorder.a9752c34.svg";